module.exports = "<div>\r\n    <reg></reg>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/reg/regIndex.html
// module id = 179
// module chunks = 0